import styled from '@emotion/styled'
import { wrap as withStyle, themeColor } from 'utils/styles'
import { SelectMenu, Paragraph } from 'components/patterns'

export default withStyle(
  () => `
  position: relative;
`
)

export const StyledSelectMenu = styled(SelectMenu)`
  margin-top: 10px;

  .ant-select {
    width: 200px;
    height: 32px;
  }
`

export const StyledRevision = styled(Paragraph)`
  padding-left: 30px;
  color: ${themeColor('inputFontSecondaryColor')};
`

export const StyledMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledDiv = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
